export interface Country {
  name: string;
  regions: Region[];
}

export interface Region {
  name: string;
  cities: City[];
}

export interface City {
  name: string;
  lat: number;
  lng: number;
}

export const country: Country[] = [
  {
    name: 'Беларусь',
    regions: [
      {
        name: 'Брестская обл.',
        cities: [
          {
            name: 'Антополь',
            lat: 52.2041343,
            lng: 24.7853018
          },
          {
            name: 'Барановичи',
            lat: 53.1255737,
            lng: 26.0091683
          },
          {
            name: 'Белоозерск',
            lat: 52.4717355,
            lng: 25.1783133
          },
          {
            name: 'Береза',
            lat: 52.5373125,
            lng: 24.9788566
          },
          {
            name: 'Береза Картуска',
            lat: 52.532746,
            lng: 24.899539
          },
          {
            name: 'Брест',
            lat: 52.0976214,
            lng: 23.7340503
          },
          {
            name: 'Высокое',
            lat: 52.367978,
            lng: 23.3759718
          },
          {
            name: 'Ганцевичи',
            lat: 52.7634482,
            lng: 26.4275001
          },
          {
            name: 'Городище',
            lat: 53.3269782,
            lng: 26.0063136
          },
          {
            name: 'Давид-Городок',
            lat: 52.0546671,
            lng: 27.2119237
          },
          {
            name: 'Домачево',
            lat: 51.7441207,
            lng: 23.5951587
          },
          {
            name: 'Дрогичин',
            lat: 52.1930413,
            lng: 25.1471719
          },
          {
            name: 'Жабинка',
            lat: 52.1954738,
            lng: 24.014935
          },
          {
            name: 'Иваново',
            lat: 52.145887,
            lng: 25.5329454
          },
          {
            name: 'Ивацевичи',
            lat: 52.7085795,
            lng: 25.3346543
          },
          {
            name: 'Каменец',
            lat: 52.3979454,
            lng: 23.8257811
          },
          {
            name: 'Кобрин',
            lat: 52.2141109,
            lng: 24.3581792
          },
          {
            name: 'Коссово',
            lat: 52.7567887,
            lng: 25.1531057
          },
          {
            name: 'Лунинец',
            lat: 52.2513941,
            lng: 26.8066432
          },
          {
            name: 'Ляховичи',
            lat: 53.0399358,
            lng: 26.2614947
          },
          {
            name: 'Малорита',
            lat: 51.7925615,
            lng: 24.0739629
          },
          {
            name: 'Микашевичи',
            lat: 52.2160531,
            lng: 27.4751997
          },
          {
            name: 'Пинск',
            lat: 52.1124967,
            lng: 26.0634602
          },
          {
            name: 'Пружаны',
            lat: 52.5557638,
            lng: 24.4554645
          },
          {
            name: 'Столин',
            lat: 51.8873063,
            lng: 26.8394148
          }
        ]
      },
      {
        name: 'Витебская обл.',
        cities: [
          {
            name: 'Барань',
            lat: 54.4788881,
            lng: 30.3160067
          },
          {
            name: 'Бегомль',
            lat: 54.7318321,
            lng: 28.0605962
          },
          {
            name: 'Бешенковичи',
            lat: 55.0444134,
            lng: 29.4559263
          },
          {
            name: 'Богушевск',
            lat: 54.8420473,
            lng: 30.2064824
          },
          {
            name: 'Браслав',
            lat: 55.6411645,
            lng: 27.0450814
          },
          {
            name: 'Верхнедвинск',
            lat: 55.7784607,
            lng: 27.9323817
          },
          {
            name: 'Ветрино',
            lat: 55.4104842,
            lng: 28.4633425
          },
          {
            name: 'Видзы',
            lat: 55.3948269,
            lng: 26.6327297
          },
          {
            name: 'Витебск',
            lat: 55.1848061,
            lng: 30.201622
          },
          {
            name: 'Воропаево',
            lat: 55.1390249,
            lng: 27.2066843
          },
          {
            name: 'Глубокое',
            lat: 55.1391321,
            lng: 27.6842904
          },
          {
            name: 'Городок',
            lat: 55.4618616,
            lng: 29.9874438
          },
          {
            name: 'Дисна',
            lat: 55.5662814,
            lng: 28.2137745
          },
          {
            name: 'Докшицы',
            lat: 54.8953858,
            lng: 27.7599272
          },
          {
            name: 'Друя',
            lat: 55.7859618,
            lng: 27.4327467
          },
          {
            name: 'Дубровно',
            lat: 54.5734035,
            lng: 30.6828298
          },
          {
            name: 'Езерище',
            lat: 55.8384089,
            lng: 29.9937851
          },
          {
            name: 'Лепель',
            lat: 54.878179,
            lng: 28.6980563
          },
          {
            name: 'Лиозно',
            lat: 55.024145,
            lng: 30.8005553
          },
          {
            name: 'Миоры',
            lat: 55.6226563,
            lng: 27.633435
          },
          {
            name: 'Новолукомль',
            lat: 54.6575917,
            lng: 29.1509792
          },
          {
            name: 'Новополоцк',
            lat: 55.5146432,
            lng: 28.5606439
          },
          {
            name: 'Орша',
            lat: 54.5071478,
            lng: 30.4119546
          },
          {
            name: 'Полоцк',
            lat: 55.4831573,
            lng: 28.7990619
          },
          {
            name: 'Поставы',
            lat: 55.1134117,
            lng: 26.8433286
          },
          {
            name: 'Россоны',
            lat: 55.9014488,
            lng: 28.8200362
          },
          {
            name: 'Сенно',
            lat: 54.8133814,
            lng: 29.7063314
          },
          {
            name: 'Толочин',
            lat: 54.4098787,
            lng: 29.6935064
          },
          {
            name: 'Ушачи',
            lat: 55.1786995,
            lng: 28.6159394
          },
          {
            name: 'Чашники',
            lat: 54.847813,
            lng: 29.1730691
          },
          {
            name: 'Шарковщина',
            lat: 55.3682716,
            lng: 27.4703402
          },
          {
            name: 'Шумилино',
            lat: 55.3000777,
            lng: 29.6112895
          }
        ]
      },
      {
        name: 'Гомельская обл.',
        cities: [
          {
            name: 'Белицк',
            lat: 52.9382677,
            lng: 30.4114864
          },
          {
            name: 'Большевик',
            lat: 52.5645365,
            lng: 30.8769586
          },
          {
            name: 'Брагин',
            lat: 51.7954009,
            lng: 30.2688788
          },
          {
            name: 'Буда-Кошелево',
            lat: 52.7201592,
            lng: 30.569225
          },
          {
            name: 'Василевичи',
            lat: 52.2443711,
            lng: 29.8315009
          },
          {
            name: 'Васильевка',
            lat: 52.2449975,
            lng: 31.5048893
          },
          {
            name: 'Ветка',
            lat: 52.5662086,
            lng: 31.1730798
          },
          {
            name: 'Гомель',
            lat: 52.4411761,
            lng: 30.9878462
          },
          {
            name: 'Добруш',
            lat: 52.4031652,
            lng: 31.3294618
          },
          {
            name: 'Ельск',
            lat: 51.8137357,
            lng: 29.1596054
          },
          {
            name: 'Житковичи',
            lat: 52.2160819,
            lng: 27.8502774
          },
          {
            name: 'Жлобин',
            lat: 52.8888952,
            lng: 30.0282481
          },
          {
            name: 'Калинковичи',
            lat: 52.1253899,
            lng: 29.3297633
          },
          {
            name: 'Корма',
            lat: 53.1307962,
            lng: 30.7935909
          },
          {
            name: 'Лельчицы',
            lat: 51.7959101,
            lng: 28.3296165
          },
          {
            name: 'Лоев',
            lat: 51.9377873,
            lng: 30.7892014
          },
          {
            name: 'Мозырь',
            lat: 52.0322082,
            lng: 29.2223129
          },
          {
            name: 'Наровля',
            lat: 51.8010382,
            lng: 29.4967759
          },
          {
            name: 'Октябрьский',
            lat: 52.6473109,
            lng: 28.8851644
          },
          {
            name: 'Петриков',
            lat: 52.1267722,
            lng: 28.4919521
          },
          {
            name: 'Речица',
            lat: 52.3635403,
            lng: 30.3923965
          },
          {
            name: 'Рогачев',
            lat: 53.0918554,
            lng: 30.0503982
          },
          {
            name: 'Светлогорск',
            lat: 52.6266995,
            lng: 29.7490257
          },
          {
            name: 'Туров',
            lat: 52.0663389,
            lng: 27.7405067
          },
          {
            name: 'Хойники',
            lat: 51.9109552,
            lng: 29.9994415
          },
          {
            name: 'Чечерск',
            lat: 52.9186475,
            lng: 30.91628
          }
        ]
      },
      {
        name: 'Гродненская обл.',
        cities: [
          {
            name: 'Берёзовка',
            lat: 53.7221715,
            lng: 25.5004738
          },
          {
            name: 'Большая Берестовица',
            lat: 53.1948656,
            lng: 24.0191604
          },
          {
            name: 'Волковыск',
            lat: 53.1516417,
            lng: 24.4422029
          },
          {
            name: 'Вороново',
            lat: 54.1499032,
            lng: 25.3160274
          },
          {
            name: 'Гродно',
            lat: 53.6693538,
            lng: 23.8131306
          },
          {
            name: 'Дятлово',
            lat: 53.4651358,
            lng: 25.4074899
          },
          {
            name: 'Желудок',
            lat: 53.5977548,
            lng: 24.9840659
          },
          {
            name: 'Зельва',
            lat: 53.1501463,
            lng: 24.8029785
          },
          {
            name: 'Ивье',
            lat: 53.9323017,
            lng: 25.777486
          },
          {
            name: 'Козловщина',
            lat: 53.3190638,
            lng: 25.2873294
          },
          {
            name: 'Кореличи',
            lat: 53.5666638,
            lng: 26.1406893
          },
          {
            name: 'Лида',
            lat: 53.8873843,
            lng: 25.2894383
          },
          {
            name: 'Мосты',
            lat: 53.4102363,
            lng: 24.5338654
          },
          {
            name: 'Новогрудок',
            lat: 53.597736,
            lng: 25.8243706
          },
          {
            name: 'Островец',
            lat: 54.6105209,
            lng: 25.9524709
          },
          {
            name: 'Ошмяны',
            lat: 54.4243464,
            lng: 25.9351597
          },
          {
            name: 'Свислочь',
            lat: 53.0358086,
            lng: 24.0942728
          },
          {
            name: 'Скидель',
            lat: 53.5866599,
            lng: 24.2503492
          },
          {
            name: 'Слоним',
            lat: 53.0875127,
            lng: 25.3087192
          },
          {
            name: 'Сморгонь',
            lat: 54.4762327,
            lng: 26.3981493
          },
          {
            name: 'Щучин',
            lat: 53.6040518,
            lng: 24.741899
          }
        ]
      },
      {
        name: 'Минская обл.',
        cities: [
          {
            name: 'Березино',
            lat: 53.8446885,
            lng: 28.9892933
          },
          {
            name: 'Бобр',
            lat: 54.3404541,
            lng: 29.2745787
          },
          {
            name: 'Борисов',
            lat: 54.2144309,
            lng: 28.508436
          },
          {
            name: 'Вилейка',
            lat: 54.4980119,
            lng: 26.9200749
          },
          {
            name: 'Воложин',
            lat: 54.0878914,
            lng: 26.533109
          },
          {
            name: 'Городея',
            lat: 53.3118876,
            lng: 26.529787
          },
          {
            name: 'Дзержинск',
            lat: 53.6849853,
            lng: 27.1325559
          },
          {
            name: 'Жодино',
            lat: 54.1016136,
            lng: 28.3471258
          },
          {
            name: 'Заславль',
            lat: 54.0006143,
            lng: 27.276841
          },
          {
            name: 'Зеленый Бор',
            lat: 54.0164763,
            lng: 28.4864947
          },
          {
            name: 'Ивенец',
            lat: 53.8882122,
            lng: 26.7405467
          },
          {
            name: 'Клецк',
            lat: 53.0637214,
            lng: 26.6392615
          },
          {
            name: 'Копыль',
            lat: 53.1511461,
            lng: 27.0908004
          },
          {
            name: 'Крупки',
            lat: 54.3269605,
            lng: 29.1426031
          },
          {
            name: 'Логойск',
            lat: 54.2042169,
            lng: 27.8532022
          },
          {
            name: 'Любань',
            lat: 52.7990255,
            lng: 27.9918895
          },
          {
            name: 'Марьина горка',
            lat: 53.506761,
            lng: 28.1527803
          },
          {
            name: 'Минск',
            lat: 53.9045398,
            lng: 27.5615244
          },
          {
            name: 'Молодечно',
            lat: 54.3104099,
            lng: 26.8488824
          },
          {
            name: 'Мядель',
            lat: 54.8771794,
            lng: 26.9388432
          },
          {
            name: 'Несвиж',
            lat: 53.2226038,
            lng: 26.6766138
          },
          {
            name: 'Пуховичи',
            lat: 53.5339049,
            lng: 28.2501616
          },
          {
            name: 'Раков',
            lat: 53.9667658,
            lng: 27.0469131
          },
          {
            name: 'Руденск',
            lat: 53.5977081,
            lng: 27.8611129
          },
          {
            name: 'Слуцк',
            lat: 53.0210495,
            lng: 27.5540131
          },
          {
            name: 'Смолевичи',
            lat: 54.0297214,
            lng: 28.0892299
          },
          {
            name: 'Солигорск',
            lat: 52.7899466,
            lng: 27.5359618
          },
          {
            name: 'Старые дороги',
            lat: 53.0389897,
            lng: 28.2605496
          },
          {
            name: 'Столбцы',
            lat: 53.4862776,
            lng: 26.7452131
          },
          {
            name: 'Узда',
            lat: 53.4619521,
            lng: 27.215089
          },
          {
            name: 'Фаниполь',
            lat: 53.746238,
            lng: 27.3375641
          },
          {
            name: 'Червень',
            lat: 53.7117479,
            lng: 28.4244728
          }
        ]
      },
      {
        name: 'Могилевская обл.',
        cities: [
          {
            name: 'Белыничи',
            lat: 53.9969111,
            lng: 29.707695
          },
          {
            name: 'Бобруйск',
            lat: 53.1446069,
            lng: 29.2213753
          },
          {
            name: 'Быхов',
            lat: 53.5180441,
            lng: 30.2402914
          },
          {
            name: 'Глуск',
            lat: 52.8996249,
            lng: 28.6709271
          },
          {
            name: 'Глуша',
            lat: 53.0864876,
            lng: 28.856285
          },
          {
            name: 'Горки',
            lat: 54.2825201,
            lng: 30.990449
          },
          {
            name: 'Гродзянка',
            lat: 53.5488048,
            lng: 28.7434739
          },
          {
            name: 'Елизово',
            lat: 53.3975307,
            lng: 29.0037835
          },
          {
            name: 'Дрибин',
            lat: 54.1190657,
            lng: 31.1014303
          },
          {
            name: 'Кировск',
            lat: 53.2691975,
            lng: 29.4765176
          },
          {
            name: 'Климовичи',
            lat: 53.6091856,
            lng: 31.9594674
          },
          {
            name: 'Кличев',
            lat: 53.4917756,
            lng: 29.3327583
          },
          {
            name: 'Костюковичи',
            lat: 53.3449659,
            lng: 32.0532332
          },
          {
            name: 'Краснополье',
            lat: 53.3383537,
            lng: 31.3972255
          },
          {
            name: 'Кричев',
            lat: 53.7093085,
            lng: 31.7171895
          },
          {
            name: 'Круглое',
            lat: 54.2483092,
            lng: 29.796286
          },
          {
            name: 'Могилев',
            lat: 53.9007159,
            lng: 30.3313598
          },
          {
            name: 'Мстиславль',
            lat: 54.0188307,
            lng: 31.7244374
          },
          {
            name: 'Осиповичи',
            lat: 53.3048792,
            lng: 28.6357281
          },
          {
            name: 'Славгород',
            lat: 53.4431223,
            lng: 30.9995629
          },
          {
            name: 'Хотимск',
            lat: 53.4099308,
            lng: 32.5773652
          },
          {
            name: 'Чаусы',
            lat: 53.8017532,
            lng: 30.953397
          },
          {
            name: 'Чериков',
            lat: 53.569694,
            lng: 31.37973
          },
          {
            name: 'Шклов',
            lat: 54.2023958,
            lng: 30.2955436
          }
        ]
      }
    ]
  }
];

export function selectCities(): City[] {
  const cities: City[] = [];

  country.forEach((co) => {
    co.regions.forEach((region) => {
      cities.push(...region.cities);
    });
  });

  return cities;
}

export function selectCitiesWithRegion(): Array<City & { region: string }> {
  const citiesWithRegion: Array<City & { region: string }> = [];

  country.forEach((co) => {
    co.regions.forEach((region) => {
      // Sort cities by name within each region
      const sortedCities = region.cities.sort((a, b) => a.name.localeCompare(b.name));

      // Add region name to each city
      sortedCities.forEach((city) => {
        const cityWithRegion: City & { region: string } = {
          ...city,
          region: region.name
        };
        citiesWithRegion.push(cityWithRegion);
      });
    });
  });

  return citiesWithRegion;
}

type RegionName =
  | 'Брестская обл.'
  | 'Витебская обл.'
  | 'Гомельская обл.'
  | 'Гродненская обл.'
  | 'Минская обл.'
  | 'Могилевская обл.';

export function getCitiesByRegionName(regionName: RegionName): City[] {
  const cities: City[] = [];

  country.forEach((c) => {
    const region = c.regions.find((region) => region.name === regionName);
    if (region) {
      cities.push(...region.cities);
    }
  });

  return cities;
}
